import React, { useState, useEffect } from 'react'
import FramePlayer from '../utils/FramePlayer'
import StartScreen from './StartScreen';
import '../css/common.css';
import '../css/intro.css';
import anime from 'animejs';

export default function Intro(props) {

    const callback = props.callback;

    useEffect(() => {
        var tl = anime.timeline({
            complete: callback
        });
        tl.add({
            targets: '#circle1',
            keyframes: [
                { r: 50, duration: 500 },
                { r: 30, cx: 540, cy: 250, duration: 900 },
                { r: 80, duration: 700 }
            ],
            easing: 'easeOutElastic(1, .8)',
        })
            .add({
                targets: '#circle2',
                r: 90,
                duration: 1200,
                easing: 'easeOutElastic(1, .8)',
            }, '-=200')
            .add({
                targets: '#circle1',
                r: 130,
                duration: 1000,
                easing: 'easeOutElastic(1, .8)',
            }, '-=700')
            .add({
                targets: '#circle3',
                r: 70,
                duration: 800,
                easing: 'easeOutElastic(1, .8)',
            }, '-=1000')
            .add({
                targets: '.black-trans-0',
                opacity: 1,
                duration: 1000,
            })

    }, []);

    return (<>
        <div className="background" >
            <img className='image-background'
                src={process.env.PUBLIC_URL + "/assets/images/intro/1.png"}
                alt="intro image"
                style={
                    { position: "absolute", left: 463, top: 70 }}
            /> <svg viewBox="0 0 660 500" >
                <mask id="circles"
                    maskUnits="objectBoundingBox" >
                    <
                        rect x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill="white" />
                    <
                        circle id="circle1"
                        cx="598"
                        cy="90"
                        r="0"
                        fill="black" />
                    <
                        circle id="circle2"
                        cx="598"
                        cy="90"
                        r="0"
                        fill="black" />
                    <
                        circle id="circle3"
                        cx="610"
                        cy="300"
                        r="0"
                        fill="black" />

                </mask>

                <
                    rect x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    fill="black"
                    style={
                        { mask: 'url(#circles)' }}
                /> </svg> <div className="black-trans-0" />
        </div> </>
    )
}